import React, { useEffect } from 'react';
import { captureLeadOrigin } from '../../utils/leadOrigin';

/**
 * Componente LeadOriginTracker
 * Executado no carregamento da aplicação para capturar a origem do lead
 * baseado em UTM parameters, ad parameters, referrer ou navegação direta
 */
function LeadOriginTracker() {
  useEffect(() => {
    captureLeadOrigin();
  }, []);

  // Este componente não renderiza nada
  return null;
}

export default LeadOriginTracker;
